import * as R from 'remeda'

/**
 * オブジェクトの配列から指定されたオブジェクトのプロパティと等しい最初の要素を返します。
 *
 * @template T - オブジェクトの型。
 * @param items - オブジェクトの配列。
 * @param obj - 検索対象のオブジェクト。
 * @returns 検索結果のオブジェクト。
 */
export function findByObj<T extends object>(
  items: T[],
  obj: Partial<T>,
): T | undefined

/**
 * オブジェクトの配列から指定されたオブジェクトのプロパティと等しい最初の要素を返します。
 *
 * @template T - オブジェクトの型。
 * @param obj - 検索対象のオブジェクト。
 * @returns オブジェクトの配列を引数に取り、検索結果のオブジェクトを返す関数。
 */
export function findByObj<T extends object>(
  obj: Partial<T>,
): (items: T[]) => T | undefined

/**
 * @param args - 引数。
 * @returns 結果または部分適用された関数。
 */
export function findByObj<T extends object>(
  ...args: [Partial<T>] | [T[], Partial<T>]
): T | ((items: T[]) => T | undefined) | undefined {
  const findByObjInner = (items: T[], obj: Partial<T>): T | undefined =>
    items.find((item) =>
      R.isDeepEqual(R.pick(item, R.keys(obj) as (keyof T)[]), obj as unknown),
    )

  if (args.length === 1) {
    return (items: T[]) => findByObjInner(items, ...args)
  }

  return findByObjInner(...args)
}
